import { ValidatorConfig } from './../../Fields/Types';
import { StringWithFormat } from '../../../types/Result';

export interface IValidator {
    validate: (value: any) => StringWithFormat | null;
};

export default function getValidator(name: string, config: ValidatorConfig): IValidator | undefined {

    switch (config.type) {
        case "isRequired":
            return new isRequiredValidator(name, config);

        case "isRequiredNumber":
            return new isRequiredNumberValidator(name, config);

        case "isMinLength":
            return new isMinLengthValidator(name, config);

        case "isMaxLength":
            return new isMaxLengthValidator(name, config);

        case "isEmail":
            return new isEmailValidator(name, config);

        case "isNumber":
            return new isNumberValidator(name, config);

        case "isDecimal":
            return new isDecimalValidator(name, config);

        case "isMinValue":
            return new isMinValueValidator(name, config);

        case "isDate":
            return new isDateValidator(name, config);

        case "isDateTime":
            return new isDateTimeValidator(name, config);

    }
}

class isRequiredValidator implements IValidator {
    name: string;
    config: ValidatorConfig;

    constructor(name: string, config: ValidatorConfig) {
        this.name = name;
        this.config = config;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'The field \'{0}\' is required!', args: [this.name] };

        //console.log('Required type:', typeof (value))

        if (Array.isArray(value) && (value === undefined || value === null || value.length === 0)) {
            return message;
        } else if (typeof (value) === 'object' && (value === undefined || value === null)) {
            return message;
        } else if (typeof (value) === 'string' && (value === undefined || value === null || value === '')) {
            return message;
        } else if (typeof (value) === 'number' && (value === undefined || value === null || value  === 0 || value.toString() === '')) {
            return message;
        } else {
            return null;
        }
    }
}

class isRequiredNumberValidator implements IValidator {
    name: string;
    config: ValidatorConfig;

    constructor(name: string, config: ValidatorConfig) {
        this.name = name;
        this.config = config;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'The field \'{0}\' is required!', args: [this.name] };

        if (value === undefined || value == null || value === '') {
            return message;
        } else {
            return null;
        }
    }
}

class isMinLengthValidator implements IValidator {
    config: ValidatorConfig;
    name: string;

    constructor(name: string, config: ValidatorConfig) {
        this.config = config;
        this.name = name;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'The field \'{0}\' must have a minimum of {1} characters!', args: [this.name, this.config.minLength] };

        if (this.config.minLength !== undefined) {
            if (value.length < this.config.minLength) {
                return message;
            }
        }
        return null;
    };
}

class isMaxLengthValidator implements IValidator {
    config: ValidatorConfig;
    name: string;

    constructor(name: string, config: ValidatorConfig) {
        this.config = config;
        this.name = name;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'The field \'{0}\' must have no more than a maximum of {1} characters!', args: [this.name, this.config.maxLength] };

        if (this.config.maxLength !== undefined) {
            if (value && value.length > this.config.maxLength) {
                return message;
            }
        }
        return null;
    };
}

class isEmailValidator implements IValidator {
    config: ValidatorConfig;
    name: string;

    constructor(name: string, config: ValidatorConfig) {
        this.config = config;
        this.name = name;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'The field \'{0}\' is not a valid email-address!', args: [this.name] };

        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value) === false) {
            return message;
        } else {
            return null;
        }
    };
}

class isNumberValidator implements IValidator {
    config: ValidatorConfig;
    name: string;

    constructor(name: string, config: ValidatorConfig) {
        this.config = config;
        this.name = name;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'The field \'{0}\' is not a valid number!', args: [this.name] };

        if (value !== undefined && value !== null && value !== '') {
            var digitRex = /^-?(\d+)$/;
            if (digitRex.test(value) === false)
                return message;
        }
        return null;

    };
}
class isDecimalValidator implements IValidator {
    config: ValidatorConfig;
    name: string;

    constructor(name: string, config: ValidatorConfig) {
        this.config = config;
        this.name = name;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'The field \'{0}\' is not a valid decimal!', args: [this.name] };

        if (value !== undefined && value !== null && value !== '') {
            var digitRex = /^-?(\d+)?.?(\d+)?$/;
            if (digitRex.test(value) === false)
                return message;
        }
        return null;

    };
}


class isMinValueValidator implements IValidator {
    config: ValidatorConfig;
    name: string;

    constructor(name: string, config: ValidatorConfig) {
        this.config = config;
        this.name = name;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'For field \'{0}\' the minimum value is {1}!', args: [this.name, this.config.minValue] };

        let floatValue = parseFloat(value);
        if (this.config.minValue !== undefined && floatValue < this.config.minValue) {
            return message;
        } else {
            return null;
        }
    };
}

class isDateValidator implements IValidator {
    config: ValidatorConfig;
    name: string;

    constructor(name: string, config: ValidatorConfig) {
        this.config = config;
        this.name = name;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'The field \'{0}\' is not a valid date!', args: [this.name] };

        if (value !== null && value !== '') {
            var digitRex1 = /^([0-9]{4})-([0-1][0-9])-([0-3][0-9])$/;
            var digitRex2 = /^([0-9]{4})-([0-1][0-9])-([0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9].\d{3}(Z)?)$/;
            var digitRex3 = /^([0-9]{4})-([0-1][0-9])-([0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9].\d{6}(Z)?)$/;
            var digitRex4 = /^([0-9]{4})-([0-1][0-9])-([0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9].\d{7}(Z)?)$/;
            var digitRex5 = /^([0-9]{4})-([0-1][0-9])-([0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9](Z)?)$/;

            if (digitRex1.test(value) === false && digitRex2.test(value) === false && digitRex3.test(value) === false && digitRex4.test(value) === false && digitRex5.test(value) === false) {
                return message;
            }
        }
        return null;
    };
}

class isDateTimeValidator implements IValidator {
    config: ValidatorConfig;
    name: string;

    constructor(name: string, config: ValidatorConfig) {
        this.config = config;
        this.name = name;
    }

    validate(value: any): StringWithFormat | null {
        let message = this.config.message
            ? this.config.message
            : { format: 'The field \'{0}\' is not a valid date/time!', args: [this.name] };

        if (value !== null && value !== '') {
            var digitRex1 = /^([0-9]{4})-([0-1][0-9])-([0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9].\d{7}(Z)?)$/;
            var digitRex2 = /^([0-9]{4})-([0-1][0-9])-([0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9].\d{6}(Z)?)$/;
            var digitRex3 = /^([0-9]{4})-([0-1][0-9])-([0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9](Z)?)$/;
            if (digitRex1.test(value) === false && digitRex2.test(value) === false && digitRex3.test(value) === false) {
                return message;
            }
        }
        return null;
    };
}